import { render, staticRenderFns } from "./SetupStatusEventsModal.vue?vue&type=template&id=1b5923c1&scoped=true&"
import script from "./SetupStatusEventsModal.vue?vue&type=script&lang=js&"
export * from "./SetupStatusEventsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5923c1",
  null
  
)

export default component.exports